var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { v4 as uuidv4, validate as validateUUID } from "uuid";
var apiEndpoints = {
    init: {
        staging: "https://staging.api.econans.se/v1/tracking/initialize",
        production: "https://api.econans.se/v1/tracking/initialize",
    },
    trackEvent: {
        staging: "https://staging.api.econans.se/v1/tracking/event",
        production: "https://api.econans.se/v1/tracking/event",
    },
};
var trackingState = {
    isMakingInitCall: false,
    hasSuccessfullyInitialized: false,
    apiEnvironment: undefined,
    apiKey: undefined,
    sessionId: uuidv4(),
    userId: uuidv4(),
    debug: false,
};
/**
 * Functions to track events to the Econans API. Sort of a better variant of Google Analytics..!
 * First call `init`, then simply call `track` to track all events. Note that both functions
 * are async and that `track` is short circuited if `init` call has not been completed.
 *
 * It's highly important that econansTracking is only used once in for example a top level component.
 * Otherwise some unique data like session id will be recreated and incorrect events send to the API.
 */
export var econansTracking = {
    init: function (_a) {
        var productId = _a.productId, productVersion = _a.productVersion, clientId = _a.clientId, userHasAcceptedCookies = _a.userHasAcceptedCookies, apiEnvironment = _a.apiEnvironment, apiKey = _a.apiKey, _b = _a.debug, debug = _b === void 0 ? false : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var cookiePrefix, savedUserId, error_1;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        cookiePrefix = "econans-tracking-user-id";
                        trackingState.apiEnvironment = apiEnvironment;
                        trackingState.apiKey = apiKey;
                        trackingState.debug = debug;
                        if (trackingState.isMakingInitCall || trackingState.hasSuccessfullyInitialized || !trackingState.apiEnvironment || !trackingState.apiKey) {
                            return [2 /*return*/];
                        }
                        if (typeof userHasAcceptedCookies === "function" ? userHasAcceptedCookies() : userHasAcceptedCookies) {
                            savedUserId = (_c = document.cookie
                                .split("; ")
                                .find(function (cookie) { return cookie.startsWith(cookiePrefix); })) === null || _c === void 0 ? void 0 : _c.split("=")[1];
                            if (typeof savedUserId === "string" && validateUUID(savedUserId)) {
                                trackingState.userId = savedUserId;
                            }
                            else {
                                document.cookie = "".concat(cookiePrefix, "=").concat(trackingState.userId, "; expires=Fri, 31 Dec 9999 23:59:59 GMT");
                            }
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        trackingState.isMakingInitCall = true;
                        return [4 /*yield*/, fetch(trackingState.apiEnvironment === "production" ? apiEndpoints.init.production : apiEndpoints.init.staging, {
                                method: "POST",
                                cache: "no-cache",
                                headers: {
                                    "Content-Type": "application/json",
                                    "api-key": trackingState.apiKey,
                                },
                                signal: AbortSignal.timeout(30000),
                                body: JSON.stringify({
                                    sessionId: trackingState.sessionId,
                                    userId: trackingState.userId,
                                    productId: productId,
                                    widgetVersion: productVersion,
                                    clientId: clientId,
                                    pageUrl: window.location.href,
                                    pageTitle: document.title,
                                    screenWidth: window.screen.width,
                                    screenHeight: window.screen.height,
                                }),
                            }).then(function (response) {
                                trackingState.hasSuccessfullyInitialized = response.ok;
                            })];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _d.sent();
                        if (trackingState.debug) {
                            // eslint-disable-next-line no-console
                            console.error(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        trackingState.isMakingInitCall = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    track: function (_a) {
        var action = _a.action, tag = _a.tag, label = _a.label, value = _a.value;
        return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!trackingState.hasSuccessfullyInitialized || !trackingState.apiEnvironment || !trackingState.apiKey) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(trackingState.apiEnvironment === "production" ? apiEndpoints.trackEvent.production : apiEndpoints.trackEvent.staging, {
                                method: "POST",
                                cache: "no-cache",
                                headers: {
                                    "Content-Type": "application/json",
                                    "api-key": trackingState.apiKey,
                                },
                                signal: AbortSignal.timeout(30000),
                                body: JSON.stringify({
                                    sessionId: trackingState.sessionId,
                                    action: action,
                                    tag: tag,
                                    label: label,
                                    value: value,
                                }),
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        if (trackingState.debug) {
                            // eslint-disable-next-line no-console
                            console.error(error_2);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
};
//# sourceMappingURL=index.js.map